// src/context/AuthContext.js
import React, { createContext, useEffect, useState } from "react";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [isLoading, setIsLoading] = useState(true);

  // 🔁 Initialisation
  useEffect(() => {
    const init = async () => {
      if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        try {
          const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/me`);
          setUser(res.data);
        } catch (err) {
          logout();
        }
      } else {
        delete axios.defaults.headers.common["Authorization"];
      }
      setIsLoading(false);
    };

    init();
  }, [token]);

  // 🔐 Connexion
  const login = async (username, password) => {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/login`, {
      username,
      password,
    });

    const receivedToken = res.data.token;
    localStorage.setItem("token", receivedToken);
    setToken(receivedToken);
    axios.defaults.headers.common["Authorization"] = `Bearer ${receivedToken}`;

    const userRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/me`);
    setUser(userRes.data);

    return { user: userRes.data };
  };

  // 🚪 Déconnexion
  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
  };

  // 🛑 Blocage tant que l'utilisateur est en cours de chargement
  if (isLoading) {
    return (
      <div style={{ textAlign: "center", padding: "3rem", color: "#fff" }}>
        Chargement...
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, setUser, token, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
